import { customAlphabet } from 'nanoid'
import { Member } from 'models/member'
import { getAnalyticsInstance } from '../analytics'

type PageViewContext = { member: Member | null; client_ip: string }

/**
 * Track PageView Event
 */
export const trackPageViewEvent = (context: PageViewContext) => {
  const { member, client_ip } = context

  const analytics = getAnalyticsInstance()

  /**
   * Generate a unique event id, so duplicate events are not sent.
   * This is primarily a problem with Meta CAPI and Meta Pixel.
   */
  const generateEventId = customAlphabet('0123456789', 12)
  const eventId = `${generateEventId()}.${generateEventId()}`
  const getEventTime = () => Math.round(new Date().getTime() / 1000)

  analytics.page(
    {
      event_id: eventId,
      event_time: getEventTime(),
      email: member?.email_address ?? '',
      first_name: member?.first_name ?? '',
      last_name: member?.last_name ?? '',
      client_ip: client_ip ?? '',
    },
    // * Fire page_view event for all analytics services except for Tealium
    { plugins: { tealium: false } },
  )
}
